import React, { Fragment, useContext } from 'react';
import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';
import Cuentas from './Cuentas';
import NuevaCuenta from '../auth/NuevaCuenta';
import Perfil from './Perfil';

const ContenedorOpcionesCuenta = () => {
    
    // Extraer funciones del context
    const barrapplContext = useContext(barraprincipalContext);
    const { vistamenu, vercuentas } = barrapplContext;

    return (
        <Fragment>
            {vistamenu === 'crearcuenta' ? (
                vercuentas ? (
                    <Cuentas />
                ): (
                    <NuevaCuenta />
                )
            ) : (
                <Perfil />
            )}
        </Fragment>
    );
}
 
export default ContenedorOpcionesCuenta;